import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AlertController, MenuController, ModalController, NavController, Platform, ToastController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { CoinGeckoService } from "../../../angular-wallet-base/services/coingecko.service";
import BigNumber from "bignumber.js";
import { getKeychain } from "../../../angular-wallet-base/store/wallet";
import {
  getTokenInfoArray,
  getTokenBalance,
  getTokenFiatValue,
  getToastPosition,
  openSetPrimaryAddressModal,
  openKYC,
  confirmstartKycAlert,
} from '../../../angular-wallet-base/utils';
import {
  ChartComponent
} from 'ng-apexcharts';
import { take } from 'rxjs/operators';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { ActivateDebitCardComponent } from 'src/app/components/activate-debit-card/activate-debit-card.component';
import { PromoModalComponent } from 'src/app/components/home-page/promo-modal/promo-modal.component';
import { getBaseCurrency } from '../../../angular-wallet-base/store/userPreferences';
import { TranslateService } from '@ngx-translate/core';
import { SmallToCryptoPipe } from '../../../angular-wallet-base/pipes/smalltocrypto/smalltocrypto.pipe';
import {
  GetTradeOrdersAction,
  GetTradeOrdersHistoryAction,
  GetPurchaseHistoryAction,
} from '../../../angular-wallet-base/actions/wallet.actions';
import * as moment from 'moment';
import { StorageService } from 'src/app/angular-wallet-base/services/storage.service';
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { GetBankAccountAssetRequestAction, GetBankAccountBalanceRequest } from 'src/app/angular-wallet-base/actions/bankAccount.actions';
import { WalletService } from 'src/app/angular-wallet-base/services/wallet.service';
import { BankAccountService } from 'src/app/angular-wallet-base/services/bank-account.service';
import { PrimetransactionsService } from 'src/app/angular-wallet-base/services/primetransactions.service';
import { ComplianceService } from '../../../angular-wallet-base/services/compliance.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { inspect } from 'util';
import { GraphService } from 'src/app/angular-wallet-base/services/graph.service';
import { GRAPH_DATA_HOME, SELL_CURRENCY, SKIP_PRIMARY_ADDRESS_MODAL, WALLET_STORAGE_KEY } from 'src/app/angular-wallet-base/constants';
import { MicroRewardService } from 'src/app/angular-wallet-base/services/micro-reward.service';
import { TradeService } from 'src/app/angular-wallet-base/services/trade.service';
import { MoralisService } from 'src/app/angular-wallet-base/services/moralis.service';
import { TokenManagerService } from 'src/app/angular-wallet-base/services/token-manager.service';
import { EnvironmentService } from 'src/app/angular-wallet-base/services/environment.service';
import { AuthService } from "../../../angular-wallet-base/services/auth.service";
import { AchAgreementModalComponent } from "../../../components/ach-agreement-modal/ach-agreement-modal.component";
import { environment } from "../../../../environments/environment";
import { getBankAccountBalance } from "../../../angular-wallet-base/store/bankAccounts";
import { WalletConnectService } from "src/app/angular-wallet-base/services/wallet-connect.service";
import { getSingularitySession, getWalletConnectInstance, getWalletConnectInstanceNonce, getWalletConnectSession } from "src/app/angular-wallet-base/store/walletConnect";
import { SingularityPaymentService } from "src/app/angular-wallet-base/services/singularity-payment.service";
import { SelectAssetModal } from 'src/app/views/select-asset-modal/select-asset-modal.component';

interface AssociatedAddress {
  id: number;
  lodeid: number;
  address_type: string;
  is_primary: boolean;
  address: string;
}
@Component({
  selector: "app-established",
  templateUrl: "./established.page.html",
  styleUrls: ["./established.page.scss"],
})
export class EstablishedPage extends SubscriptionListenerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('chart', { static: false }) chart: ChartComponent;
  public chartOptions;
  public activeYAxis = 5;
  public showChart = false;
  public waveSvg = 'prime';
  public activeOptionButton = 'ALL';
  public selectedDate = '';
  public totalBalance = 0; // eric todo make it as observal
  public performanceOfTotal = '';
  public updateOptionsData;
  public items = [];
  public isDesktopMode: boolean;
  public showPromoOffer: boolean = false;
  private promoInterval;
  public currentBaseCurrency: string;
  public totalAssetBalance = 0;
  public isAssetLoaded = false;
  public isLoadingPrime = false;
  public userCompletedKyc;

  public txHistory = [];
  public limitexec = false;
  public isrepeated = false;
  // public priceDataCoin;
  public marketprice: any = {};
  public walletAddress;
  public mapTransactionData: any = {};
  public tempDateTransaction;
  public transactionDates: any = [];
  public transactiondateMap: any = {};
  public selectedAsset: any;
  public selectedAssetKeyringId: any;
  public selectedAssetBasechain: any;

  public mapPlotData = {};
  public mapStoredData = [];
  public lastEntry;
  public currentDate;
  public lastCoinCount = 0;
  public assetStorageData = [];
  public storedCurrency = "";
  public formattedPriceList = {};
  public achLoadingSpinner: boolean;
  public growthPercentage: any = {
    percentage: 0,
    amount: 0,
  };
  public fiatBalance: any;
  public assetBalance: any;
  public totalPrimeBalance = 0;
  public chartYAxis = [];
  public associateAddressOfUser: AssociatedAddress;
  public isPrimaryAddressSet: boolean = false;
  public isACHEnabled = environment.features.bankAccounts;
  public isWalletConnectEnabled = false;
  public tradeFeature = this.environmentService.trade;
  public isIos = true;
  public isAchRole = false;
  private achFiatBalance = 0;
  private achAssetBalance = 0;
  private flipped = false;
  private flipInterval: any = null;

  constructor(
    protected store: Store<AppState>,
    private modalController: ModalController,
    private nav: NavController,
    private menu: MenuController,
    public appMode: AppModeService,
    private storage: StorageService,
    private platform: Platform,
    private translate: TranslateService,
    private complianceService: ComplianceService,
    private smallToCrypto: SmallToCryptoPipe,
    private coinGecko: CoinGeckoService,
    private oneInchService: OneInchService,
    private walletService: WalletService,
    private bankAccountService: BankAccountService,
    private alert: AlertController,
    private toast: ToastController,
    private primetransactions: PrimetransactionsService,
    private graphService: GraphService,
    private authService: AuthService,
    public microRewardService: MicroRewardService,
    private moralisService: MoralisService,
    private tradeService: TradeService,
    private tokenService: TokenManagerService,
    private environmentService: EnvironmentService,
    private walletConnectService: WalletConnectService,
    private singularityPaymentService: SingularityPaymentService,
  ) {
    super(store);
    this.chartYAxis = this.graphService.chartYAxis.getValue();
    this.updateOptionsData = this.graphService.updateOptionsData.getValue();
    this.appMode.isDesktopMode.subscribe((mode) => (this.isDesktopMode = mode));
    const tabInstance = this;
    this.isAssetLoaded = false;
    this.isIos = this.platform.is('ios');
    
  }

  async ngOnInit() {
    // fetch chart options from service
    this.chartOptions = await this.graphService.getHomePagechartOptions(this.isDesktopMode, this);
    this.currentBaseCurrency = await this.store.select(getBaseCurrency).pipe(take(1)).toPromise();

    await this.getAssets();
    
    if (!this.platform.is("cordova")) {
      this.kycCheck();
      this.store.dispatch(new GetPurchaseHistoryAction());
    }
    // this.getPrimeTransactionsWithAsset()
    this.getPrimeFiatAndAssetBalance();
    this.storage.get(SKIP_PRIMARY_ADDRESS_MODAL).then(async (val) => {
      Logger.info('SKIP_PRIMARY_ADDRESS_MODAL ', val);
      if (val === null) { // when user first time login and don't have associate address
        await this.microRewardService.showAssociateAddressModal(true);
        await this.showPrimaryAddressModal();
      } else {
        if (val) await this.showPrimaryAddressModal();
      }
    });

    
    this.walletConnectService.initiateWalletConnectWeb3Instance();
    this.store.select(getWalletConnectInstance).subscribe(web3WalletInstance => {
      Logger.info(`getWalletConnectInstance ${web3WalletInstance}`);
      if (web3WalletInstance) {
        this.singularityPaymentService.initializedSingularityPayment();
      }
    })
  
    this.store.select(getWalletConnectInstanceNonce).subscribe(async web3WalletNonce => {
      Logger.info(`getWalletConnectInstanceNonce ${web3WalletNonce}`);
      const web3Wallet = await this.store.select(getWalletConnectInstance).pipe(take(1)).toPromise();
      await this.walletConnectService.subscribeProposalSessionFromDapp(web3Wallet);
    });
    this.store.select(getSingularitySession).subscribe(async session => {
      Logger.info(`getSingularitySession`);
      await this.walletConnectService.subscribeWalletConnectEvents();
    })

    this.store.select(getWalletConnectSession).subscribe(async session => {
      await this.walletConnectService.subscribeWalletConnectEvents();
    })

    //see if user has ACH_GROUP role
    this.isAchRole = await this.authService.hasGroup('GROUP_ACH');
    this.isWalletConnectEnabled = this.environmentService.service('walletConnect') && (await this.authService.hasGroup('GROUP_WALLETCONNECT')) && (await this.storage.get(WALLET_STORAGE_KEY));

    // promo card flipping anim
    this.startFlipInterval();
  }

  startFlipInterval() {
    this.flipInterval = setInterval(() => {
      this.flipped = !this.flipped;
    }, 15000);
  }

  async showPrimaryAddressModal() {
    // check whether the user is set Primary Address

    if (this.microRewardService.isDisplayAssociateAddressModal) {
      Logger.info('displayAddressModal ', this.microRewardService.isDisplayAssociateAddressModal);
      const address = await this.microRewardService.getAssociateAddressOfUser();
      const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
      if (address?.associated_addresses?.length > 0) {
        this.associateAddressOfUser = address.associated_addresses.find((address: { is_primary: boolean; }) => address.is_primary);
        this.isPrimaryAddressSet = this.associateAddressOfUser ? true : false;
      }
    }
  }

  async ngAfterViewInit() {
    await this.menu.enable(true, "sideMenu");
  }

  async ionViewDidEnter() {
    // MOBILE: ngAfterViewInit and ngOnInit appear to not fire after authenticate so we use ionViewDidEnter here
    await this.menu.enable(true, "sideMenu");

    if (this.platform.is("cordova")) {
      // this.kycCheck();
      this.store.dispatch(new GetPurchaseHistoryAction());
    }
  }
  async ionViewWillEnter() {
    this.currentBaseCurrency = await this.store.select(getBaseCurrency).pipe(take(1)).toPromise();
    this.storage.get(SELL_CURRENCY).then(async (val) => {
      Logger.info('SELL_CURRENCY', val);
      this.storedCurrency = val;
      await this.fetchStorageData(val);
    });
  }

  async getAssets() {
    // var assetBalances = {}
    await this.graphService.get365DatesFromToday();
    this.subscriptions.add(
      this.store.select(getKeychain).subscribe(async (keychain) => {
        if (!keychain) {
          // Prevent error on wallet reset.
          return;
        }
        let tokens = await Promise.all(
          getTokenInfoArray(keychain)
            .sort((a, b) => a?.symbol?.charCodeAt(0) - b?.symbol?.charCodeAt(0))
            .map(async (token) => {
              try {
                const tokenCopy: any = { ...token };
                tokenCopy.balance = tokenCopy.balance ? tokenCopy.balance.toString() : "0";
                return tokenCopy;
              } catch (error) {
                Logger.error('getTokenInfoArray', error);
                return null;
              }
            })
        );
        this.isAssetLoaded = tokens.length > 6 ? true : false;

        Logger.info(`home tokens -  ${inspect(tokens)}`);
        tokens = tokens.filter(token => token.baseChainSymbol != 'HL');
        this.getBalance(tokens);

        if (tokens.length > 6) {

          if ((this.mapStoredData.length === 0)) {
            if (this.isAssetLoaded) {
              await this.getMarketHistoryAndTransactionHistoryOfTokens(tokens);
            }
          } else if (this.mapStoredData[0][2] !== moment().format('MM/DD/YYYY') ||
            (this.storedCurrency && (this.currentBaseCurrency !== this.storedCurrency))) {
            if (this.isAssetLoaded) {
              await this.getMarketHistoryAndTransactionHistoryOfTokens(tokens);
            }
          }

          // send the user's token list for the first time
          await this.tokenService.addTokenAddressForFirstTime().then(async (_) => {
            // cache all available liquidity
            await this.tradeService.setAvailableLiquidityPairs();
          });

          if (this.tradeFeature) {
            // trade - get order list and history
            // remove OneInche
            //const tradeOrderProgress = this.oneInchService.orderProgress.getValue();
            //const tradeOrderHistoryProgress = this.oneInchService.orderProgress.getValue();
            //if (!tradeOrderProgress) { this.store.dispatch(new GetTradeOrdersAction(true)); }
            //if (!tradeOrderHistoryProgress) { this.store.dispatch(new GetTradeOrdersHistoryAction(true)); }
          }

          // initiate moralis service
          await this.moralisService.getHiddenAssetsFromMoralisScheduler();
        }
      })
    );
  }

  

  private async getBalance(tokens) {
    Logger.info("tokenslist", tokens);

    let newAssetBalance = 0.0;
    // calculate total fiat balance using only tokens that have an available fiatValue
    for (const token of tokens) {
      try {
        if (token.fiatValue) {
          let num = getTokenFiatValue(token.fiatValue, getTokenBalance(token));
          num = this.smallToCrypto.transform(num, { type: token.baseChainSymbol, precision: token.precision });
          newAssetBalance += new BigNumber(num).toNumber();
        }
      } catch (e) {
        Logger.error("HomePage - getBalance - token - error", token, inspect(e));
      }
    }
    this.totalAssetBalance = newAssetBalance;
    this.storage.totalBalance.next(this.totalAssetBalance);
  }

  async getMarketHistoryAndTransactionHistoryOfTokens(tokens) {
    try {
      Logger.info("getMarketHistoryAndTransactionHistoryOfTokens ", tokens, this.currentBaseCurrency);
      this.storage.set(SELL_CURRENCY, this.currentBaseCurrency);
      const res = await this.graphService.calculatePriceOfTransactionHistory();
      if (res) {
        this.fetchStorageData(this.currentBaseCurrency);
      }
    } catch (error) {
      Logger.error("fetch market history or transaction history error", error);
    }
  }

  async getPrimeTransactionsWithAsset() {
    this.primetransactions.getPrimeAssetTransaction("FIAT", 1, 100).then((data: any) => {
      Logger.info("prime fiat", data);
    });
  }

  async fetchStorageData(val) {
    Logger.info("fetchStorageData ", val, this.currentBaseCurrency);
    if (this.currentBaseCurrency !== val) {
      await this.storage.remove(GRAPH_DATA_HOME);
      this.mapStoredData = [];
    } else {
      this.mapStoredData = await this.storage.get(GRAPH_DATA_HOME);
      Logger.info("this.mapStoredData ", this.mapStoredData);
      if (this.mapStoredData && this.mapStoredData.length > 0) {
        this.chartOptions.series[0].data = [];
        this.chartOptions.series[0].data = this.mapStoredData;
        this.initChart();
      } else {
        this.mapStoredData = [];
      }
    }
  }

  async kycCheck() {
    this.userCompletedKyc = (await this.complianceService.getKycCip()).passingLevel;
    this.store.dispatch(new GetBankAccountAssetRequestAction());
    this.store.dispatch(new GetBankAccountBalanceRequest());
  }

  getPrimeFiatAndAssetBalance() {
    this.totalPrimeBalance = 0;
    this.subscriptions.add(this.store.select(getBankAccountBalance).subscribe((balanceState) => {
      this.achFiatBalance = balanceState?.amount || 0;
      this.totalPrimeBalance = this.achFiatBalance + this.achAssetBalance;
    }));
    // this.subscriptions.add(
    //   this.store.select(getPTTokens).subscribe(async (assets) => {
    //     this.achAssetBalance = assets.reduce((acc, asset) => {
    //       return acc + asset.balance;
    //     }, 0);
    //     this.totalPrimeBalance = this.totalPrimeBalance + this.fiatBalance;
    //     this.Totalbalance = this.totalAssetBalance + this.totalPrimeBalance;
    //   })
    // );
  }

  async initChart() {
    this.showChart = true;
    this.updateOptions("ALL");
  }

  public updateOptions(option: any): void {
    Logger.info("option ", option);

    this.selectedDate = "";
    this.activeOptionButton = option;
    // this.getWalletAssetGrowth(option);
    const updatedOptions = this.updateOptionsData[option];
    const updatedData = [];
    for (const data of this.mapStoredData) {
      if (data[0] <= updatedOptions.xaxis.max && data[0] >= updatedOptions.xaxis.min) {
        updatedData.push(data);
      }
    }
    if (updatedData.length > 0) {
      updatedOptions.xaxis.max = updatedData[0][0];
      updatedOptions.xaxis.min = updatedData[updatedData.length - 1][0];
    }
    this.chart.updateOptions(updatedOptions, false, true, true);
  }

  resetChart() {
    this.activeOptionButton = "ALL";
    this.selectedDate = "";
    this.showChart = false;
    this.initChart();
  }

  async loadDebitCard() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();

    let cssClass = "vault-promo-modal";
    cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";

    const modal = await this.modalController.create({
      component: ActivateDebitCardComponent,
      cssClass,
    });
    modal.onDidDismiss().then();
    await modal.present();
  }

  async promoBannerInfo() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();

    let cssClass = "vault-promo-modal";
    cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";

    const modal = await this.modalController.create({
      component: PromoModalComponent,
      cssClass,
    });
    modal.onDidDismiss().then();
    await modal.present();
  }

  isExpandChange(i, item) {
    if (item.blockchains.length > 0) {
      this.items[i].isExpanded = !this.items[i].isExpanded;
    } else {
      this.nav.navigateForward(["/vault-intro", item.asset]);
    }
  }

  toVaultPage() {
    this.walletService.setWalletType("vault");
    this.nav.navigateForward("vault-intro");
  }

  async toBuyPage() {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    let cssClass = "";
    cssClass += this.isDesktopMode ? "select-asset-modal-desktop" : "select-asset-modal";
    cssClass += !sideMenuHidden && this.isDesktopMode ? " with-side-menu" : "";
    const modal = await this.modalController.create({
      component: SelectAssetModal,
      componentProps: {
        actionType: 'buy',
        // newMember: this.applyPromo == true ? true : false,
        // promocode: this.applyPromo == true ? this.newMemberOfferData.attributes.code : null
      },
      cssClass,
      id: 'select-asset-model',
      initialBreakpoint: this.isDesktopMode ? undefined : 0.9,
      breakpoints: this.isDesktopMode ? undefined : [0, 0.6, 0.9, 1],
    });
    await modal.present();
  }

  toVaultDebitPage() {
    this.nav.navigateForward("my-cards");
  }

  @AuthService.requireGroup('GROUP_ACH')
  async toPrimePage() {
    this.isLoadingPrime = true;
    this.walletService.setWalletType("prime");
    //check if prime trust kyc is completed for sumsub
    const kycStatusForPrimeTrustCompleted: boolean = await this.complianceService.verifyIfKYCIsCompleted("BasicFlowPrimeTrust");
    Logger.info(kycStatusForPrimeTrustCompleted);
    //if kyc is not completed, show kyc sumsub modal and begin kyc flow
    if (!kycStatusForPrimeTrustCompleted) {
      //get sumsubwidget data for prime
      const handler = async () => {
        openKYC(
          this.achLoadingSpinner,
          this.complianceService,
          this.translate,
          this.toast,
          this.modalController,
          this.platform,
          undefined,
          "BasicFlowPrimeTrust"
        );
      };
      confirmstartKycAlert(this.alert, this.translate, handler);
      this.achLoadingSpinner = false;
      return;
    }
    //check if prime trust ach account exists
    const accountExists = await this.bankAccountService.getACHStatus();
    Logger.info("accountExists", accountExists);
    this.isLoadingPrime = false;
    //if prime trust account exists and sumsub kyc is completed, navigate to bank account page
    if (accountExists && kycStatusForPrimeTrustCompleted) {
      this.achLoadingSpinner = false;
      this.nav.navigateForward("prime");
      return;
    } else {
      //get prime trust agreement
      const agreementData: any = await this.bankAccountService.getAchAgreement();
      // Error is sent in an array so if not an array API success
      if (this.isDesktopMode) {
        const modal = await this.modalController.create({
          component: AchAgreementModalComponent,
          componentProps: {
            agreementData: agreementData.attributes.content,
          },
          cssClass: "ach-modal-css",
        });
        this.achLoadingSpinner = false;
        await modal.present();
      } else {
        this.achLoadingSpinner = false;
        this.nav.navigateForward("/wallet/ach_agreement");
        return;
      }
    }
  }

  async presentToast(hdr, msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000,
    });
    await toast.present();
  }

  async checkPTKycApproval() {
    try {
      const ptKycDataRes = await this.bankAccountService.getPTKycApproveStatus();
      const ptKycData = JSON.parse(ptKycDataRes.toString());
      Logger.info(ptKycData);
      if (!ptKycData.aml.status || !ptKycData.cip.status) {
        this.bankAccountService.showKYCStatus(ptKycData);
      } else {
        this.nav.navigateForward("ach");
      }
      this.achLoadingSpinner = false;
    } catch (e) {
      Logger.info(e);
      if (e.status === 422) {
        return this.bankAccountService.showKYCStatus(JSON.parse(e.error));
      }
      this.achLoadingSpinner = false;
    }
  }

  toTradePage() {
    this.nav.navigateForward('trade');
  }

  doStripePayment() {
    const url = 'https://crypto.link.com/?ref=lb&source_amount=1000&source_currency=usd&destination_currency=avax&destination_network=avalanche';
    window.open(url, '_blank');  
  }

  redirectToWeex() {
    window.open('https://www.weex.com/register?vipCode=ywtt', '_blank');
  }

  ngOnDestroy() {
    clearInterval(this.promoInterval);
    if (this.flipInterval) {
      clearInterval(this.flipInterval);
    }
  }
}
